// eslint-disable-next-line no-restricted-imports,import/order
import { nonProductionColor } from '../theme/palette';

// eslint-disable-next-line no-restricted-imports
import { defaultFeatureFlags, FeatureFlags } from '../config/featureFlags.types';

export const LOCALSTORAGE_PREFIX = 'pcm-clm-portal/';

export type EnvironmentName =
  | 'local'
  | 'cloud'
  | 'pcm-development'
  | 'pcm-skaffold'
  | 'pcm-sandbox'
  | 'pcm-tst50'
  | 'pcm-uat1'
  | 'pcm-uat2'
  | 'pcm-prd'
  | 'pcm-prd2'
  | 'pcm-prd20'
  | 'unknown';

export const IframeComponents = [
  'partnerProfileIframe',
  'partnerCoreIframe',
  'brCoreIframe',
  'brPurposeIframe',
  'brApprovalIframe',
  'productAndServicesIframe',
  'pcdV2Iframe',
  'dossierIframe',
  'wealthOverviewIframe',
  'investmentProfileIframe',
  'contactNoteIframe',
  'pcdClientDocumentTemplateIframe',
  'pcmReportingIframe',
  'riskConsiderationsIframe',
  'globalPartnerHandlerIframe',
  'catActivityTimelineIframe',
  'msdIframe',
  'caseManagerIframe',
  'pmkTaskViewerIframe',
  'accountRelationsServiceIframe',
  'lscServiceIframe',
  'pmkWorkflowDashboardIframe',
  'clmPortalIframe',
] as const;
export type IframeComponent = (typeof IframeComponents)[number];

export interface RuntimeConfig {
  env: EnvironmentName;
  bannerColour: string;
  featureFlags?: FeatureFlags;
  urls?: string[];
  iframeUrls: Record<IframeComponent, string>;
  gravityUrl?: string;
  gravityEnabledByDefault: boolean;
}

export const baseConfig = {
  bannerColour: nonProductionColor,
  featureFlags: defaultFeatureFlags,
  iframeUrls: Object.fromEntries(IframeComponents.map((component) => [component, ''])) as Record<
    IframeComponent,
    string
  >,
  gravityEnabledByDefault: false,
} as const;
